import React from "react";
import classnames from "classnames";
import Container from "../components/misc/Container";
import LayoutHomepage from "../layout/LayoutHomepage";
import FlashBrokoli from "../assets/images/brokoli.png";
import JagungManis from "../assets/images/sayur/buah/jagung.jpeg";
import Wortel from "../assets/images/sayur/akar/wortel.jpeg";
import Daging from "../assets/images/daging/sapi.jpeg";

import FlashSale from "../assets/icons/flash-sale.svg";
import { Link } from "react-router-dom";
import ButtonPrimary from "../components/misc/ButtonPrimary";
import Pagination from "../components/misc/Pagination";
import DynamicScrollToTop from "../components/misc/DynamicScrollToTop";

const FlashDeal = () => {
  let flashDealItem = [
    {
      imgSrc: FlashBrokoli,
      itemName: "Brokoli",
      imgAlt: "Brokoli",
      weight: "250gr",
      price: "Rp2500",
      discountPrice: "Rp5000",
      stock: "5",
      precentage: "20",
    },
    {
      imgSrc: JagungManis,
      itemName: "Jagung",
      imgAlt: "Jagung",
      weight: "250gr",
      price: "Rp2500",
      discountPrice: "Rp5000",
      stock: "5",
      precentage: "50",
    },
    {
      imgSrc: Wortel,
      itemName: "Wortel",
      imgAlt: "Wortel",
      weight: "250gr",
      price: "Rp6500",
      discountPrice: "Rp5500",
      stock: "15",
      precentage: "40",
    },
    {
      imgSrc: Daging,
      itemName: "Daging",
      imgAlt: "Daging",
      weight: "250gr",
      price: "Rp20000",
      discountPrice: "Rp25000",
      stock: "30",
      precentage: "80",
    },
  ];

  return (
    <>
      <DynamicScrollToTop />
      <LayoutHomepage>
        <div className="flex flex-col w-full mt-32">
          <Container>
            <div className="flex flex-col w-full mr-2 mb-6">
              <div className="flex w-full mt-8 mb-2">
                <Link to="/homepage">
                  <p className="flex items-center text-font-gray opacity-50">
                    Beranda{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-3 h-3 opacity-100 mx-2"
                      viewBox="0 0 11.384 20.025"
                    >
                      <g
                        id="Group_4034"
                        data-name="Group 4034"
                        transform="translate(1.414 1.414)"
                      >
                        <line
                          id="Line_452"
                          data-name="Line 452"
                          x2="12.099"
                          transform="translate(8.555 8.642) rotate(135)"
                          fill="none"
                          stroke="#596375"
                          strokeLinecap="round"
                          strokeWidth="2"
                        />
                        <line
                          id="Line_453"
                          data-name="Line 453"
                          x2="12.099"
                          transform="translate(8.555 8.555) rotate(-135)"
                          fill="none"
                          stroke="#596375"
                          strokeLinecap="round"
                          strokeWidth="2"
                        />
                      </g>
                    </svg>
                  </p>
                </Link>
                <h1 className="text-font-gray">Flash deal</h1>
              </div>
              <div className="py-2 rounded">
                <div className="flex px-1  border-gray-300 pb-4">
                  <div className="flex items-center">
                    <h5 className="text-3xl font-semibold text-font-gray mb-2">
                      Flash Deal
                    </h5>
                    <img className="ml-2 mb-2 h-5 w-5" src={FlashSale} alt="" />
                  </div>
                  <button className="text-sm flex items-center ml-auto bg-orange-linen-400 border-basic-orange text-grey-500 border-2 px-4 py-2 rounded-md">
                    <p className="uppercase mr-4">Berakhir dalam</p>{" "}
                    <span className="bold italic text-basic-orange">
                      {" "}
                      08:06:00
                    </span>
                  </button>
                </div>
                <div className="flex py-4 flex-wrap -mx-4">
                  {flashDealItem.map((item, index) => (
                    <div className="p-4 w-3/12 ">
                      <div className="bg-white rounded-md">
                        <div className="flex flex-col px-8 py-10 w-full">
                          <Link to="/flashdetail">
                            <img
                              src={item.imgSrc}
                              alt={item.imgAlt}
                              className="w-full"
                            />
                          </Link>
                          <div className="flex flex-col mb-4">
                            <h5 className="text-font-gray text-2xl font-semibold">
                              {item.itemName}
                            </h5>
                            <small className="text-font-gray opacity-50 text-lg">
                              {item.weight}
                            </small>
                          </div>
                          <div className="flex flex-col">
                            <p className="text-font-gray-light line-through">
                              {item.price}
                            </p>
                            <p className="text-basic-orange text-xl">
                              {item.discountPrice}
                            </p>
                          </div>
                          <div className="flex w-full items-center justify-between">
                            <div className="relative flex-grow mr-4">
                              <div className="overflow-hidden h-5 text-xs flex rounded bg-gray-400 rounded-l-full rounded-r-full">
                                <div
                                  style={{ width: item.precentage + "%" }}
                                  className={classnames("shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center",{
                                    "bg-orange-400" : 
                                    item.precentage <= 50 && item.precentage > 20,
                                    "bg-green-700" : 
                                    item.precentage > 50,
                                    "bg-red-700" : 
                                    item.precentage <= 20,
                                  }
                                  )}
                                >
                                  <p className="absolute py-2 mx-auto w-full">
                                    {item.stock} Tersisa
                                  </p>
                                </div>
                              </div>
                            </div>
                            <Link to="/flashdetail">
                              <ButtonPrimary text="sm">Beli</ButtonPrimary>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className=" flex w-full">
                <div className="ml-auto">
                  <Pagination />
                </div>
              </div>
            </div>
          </Container>
        </div>
      </LayoutHomepage>
    </>
  );
};

export default FlashDeal;
